/**
 * Permission task definitions for the Helpdesk feature, used to control access
 * to tickets, ticket entries, and ticket attachments.
 *
 * @module permissions/helpdesk
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * Permission map for the Helpdesk feature.
 *
 * Each key is a resource and each nested key is an operation (view/create/update/delete).
 * The `task` string must exactly match the `name` field in the `permission_tasks` collection.
 *
 * @type {Object.<string, Object.<string, {task: string, type: string}>>}
 */
const helpdesk = {
    tickets: {
        view: {
            task: 'Helpdesk Ticket',
            type: 'view',
        },
        create: {
            task: 'Helpdesk Ticket',
            type: 'create',
        },
        update: {
            task: 'Helpdesk Ticket',
            type: 'update',
        },
        delete: {
            task: 'Helpdesk Ticket',
            type: 'delete',
        },
    },
    ticket_entries: {
        view: {
            task: 'Helpdesk Ticket Entries',
            type: 'view',
        },
        create: {
            task: 'Helpdesk Ticket Entries',
            type: 'create',
        },
        update: {
            task: 'Helpdesk Ticket Entries',
            type: 'update',
        },
        delete: {
            task: 'Helpdesk Ticket Entries',
            type: 'delete',
        },
    },
    ticket_attachments: {
        view: {
            task: 'Helpdesk Ticket Attachments',
            type: 'view',
        },
        create: {
            task: 'Helpdesk Ticket Attachments',
            type: 'create',
        },
        update: {
            task: 'Helpdesk Ticket Attachments',
            type: 'update',
        },
        delete: {
            task: 'Helpdesk Ticket Attachments',
            type: 'delete',
        },
    },
};
export default helpdesk;
